// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"748":"6d77eed1","2393":"1b873426","2924":"1941d1fb","3396":"97ba655c","3677":"a9c24084","3749":"ff351404","3757":"4fa8f711"}[chunkId] + ".chunk.css";
};